import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, GraduationCap } from 'lucide-react';
import { Button } from '../components/ui/button';
import AcademyTab from '../components/admin/Academy/AcademyTab';

const StaffAcademyPage = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-emerald-600 text-white">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <button
            onClick={onBack}
            className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/15 hover:bg-white/25 transition-colors text-sm font-medium"
            data-testid="academy-back-btn"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour au menu
          </button>
          <div className="flex items-center gap-2">
            <GraduationCap className="w-6 h-6" />
            <h1 className="font-display text-lg md:text-xl font-semibold">SADA Academy</h1>
          </div>
          <div className="w-28" />
        </div>
      </header>

      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="max-w-6xl mx-auto px-4 py-6"
      >
        <AcademyTab />
      </motion.div>
    </div>
  );
};

export default StaffAcademyPage;
